import React, { useState } from "react";
import "../styles/App.css";

export default function MainContent({
  sections,
  draggedId,
  dragOverId,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
  mode,
}) {
  const [collapsedSections, setCollapsedSections] = useState({});
  const [expandedDetails, setExpandedDetails] = useState({});

  const toggleSection = (id) => {
    setCollapsedSections((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const toggleDetails = (id) => {
    setExpandedDetails((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <main id="main-content">
      {mode === "minimal" && (
        <div id="resume-header">
          <div className="name-display">
            <em>Nathan</em> Marcos<br />
            Linhares Silva <em>Martins</em>
          </div>
          <div className="role-tag">
            Advertiser &middot; Visual Designer &middot; Front-End Developer
          </div>
          <p className="profile-text">
            Brazilian advertiser based in Amsterdam. 10+ years in visual & graphic
            design, UX/UI, and front-end development &mdash; with a strong background
            in video production and motion graphics. I create purposeful, polished
            work across Retail, Healthcare, IT, Digital Marketing, Architecture, and
            Events.
          </p>
          <div id="minimal-contact-bar">
            <a href="https://nathan.marketing" target="_blank">
              🌐 nathan.marketing
            </a>
            <a href="mailto:nathanmls@hotmail.com">
              ✉️ nathanmls@hotmail.com
            </a>
            <a href="tel:+31627293829">
              📞 +31 627 29 3829
            </a>
            <span>📍 Amsterdam, NL</span>
          </div>
        </div>
      )}

      <div id="sections-container">
        {sections.map((section) => {
          const isCollapsed = collapsedSections[section.id];
          const isDragging = draggedId === section.id;
          const isOver = dragOverId === section.id;

          return (
            <section
              key={section.id}
              className={`resume-section ${
                isDragging ? "dragging" : ""
              } ${isOver ? "dragOver" : ""}`}
              draggable
              onDragStart={() => onDragStart(section.id)}
              onDragOver={(e) => onDragOver(e, section.id)}
              onDrop={() => onDrop(section.id)}
              onDragEnd={onDragEnd}
              style={{ animationDelay: `${section.id === "experience" ? "0.05s" : section.id === "skills" ? "0.1s" : section.id === "education" ? "0.15s" : "0.2s"}` }}
            >
              <div
                className="section-header"
                onClick={() => toggleSection(section.id)}
              >
                <div className="section-title">
                  <span
                    className="section-drag-handle"
                    draggable={false}
                    onClick={(e) => e.stopPropagation()}
                    title="Drag to reorder"
                  >
                    ⠿
                  </span>
                  <span className="s-icon">{section.icon}</span>&#32;{
                    section.title
                  }
                </div>
                <button
                  className={`section-toggle ${isCollapsed ? "" : "open"}`}
                  id={`toggle-sec-${section.id}`}
                >
                  {isCollapsed ? "▸" : "▾"}
                </button>
              </div>

              <div
                className={`section-body ${isCollapsed ? "collapsed" : ""}`}
                id={`body-sec-${section.id}`}
              >
                {section.id === "experience" && (
                  <>
                    <div
                      className="exp-item"
                      id="exp-lebanese"
                    >
                      <div className="exp-dot" />
                      <div className="exp-info">
                        <div className="exp-title">Stand-in Worker</div>
                        <div className="exp-meta">
                          <span className="exp-company">The Lebanese Sajeria</span>
                          <span className="exp-year">2026</span>
                        </div>
                        <div className="exp-tags">
                          <span className="exp-tag">Kitchen Assist</span>
                          <span className="exp-tag">Cashier</span>
                          <span className="exp-tag">Runner</span>
                        </div>
                      </div>
                    </div>

                    <div
                      className="exp-item"
                      id="exp-keukenhof"
                    >
                      <div className="exp-dot" />
                      <div className="exp-info">
                        <div className="exp-title">
                          Medewerker Bediening Horeca
                        </div>
                        <div className="exp-meta">
                          <span className="exp-company">Keukenhof &ndash; Albron</span>
                          <span className="exp-year">2024</span>
                        </div>
                        <div className="exp-tags">
                          <span className="exp-tag">Kitchen Assist</span>
                          <span className="exp-tag">Coffee Corner</span>
                          <span className="exp-tag">Cashier</span>
                          <span className="exp-tag">Runner</span>
                        </div>
                      </div>
                    </div>

                    <div
                      className="exp-item"
                      id="exp-luxura"
                    >
                      <div className="exp-dot" />
                      <div className="exp-info">
                        <div className="exp-title">Visual Designer</div>
                        <div className="exp-meta">
                          <span className="exp-company">Luxura Spa</span>
                          <span className="exp-year">2023</span>
                        </div>
                        <div className="exp-tags">
                          <span className="exp-tag">Social Media</span>
                          <span className="exp-tag">Landing Pages</span>
                          <span className="exp-tag">Email Marketing</span>
                          <span className="exp-tag">Video</span>
                        </div>
                        <button
                          className="expand-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleDetails("exp-luxura");
                          }}
                        >
                          {expandedDetails["exp-luxura"] ? "▾ Hide details" : "▸ Details"}
                        </button>
                        <div className="exp-desc">
                          Created engaging and cohesive visual content across brand
                          channels&mdash;social media posts, email campaigns,
                          conversion-focused landing pages, and video editing.
                          Helped Luxura Spa connect with customers and achieve
                          planned marketing goals through graphic design,
                          copywriting, and video production.
                        </div>
                      </div>
                    </div>

                    <div
                      className="exp-item"
                      id="exp-elevenrush"
                    >
                      <div className="exp-dot" />
                      <div className="exp-info">
                        <div className="exp-title">UX Designer</div>
                        <div className="exp-meta">
                          <span className="exp-company">ElevenRush</span>
                          <span className="exp-year">2021</span>
                        </div>
                        <div className="exp-tags">
                          <span className="exp-tag">React</span>
                          <span className="exp-tag">Chakra UI</span>
                          <span className="exp-tag">MailChimp</span>
                          <span className="exp-tag">SEO</span>
                        </div>
                        <button
                          className="expand-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleDetails("exp-elevenrush");
                          }}
                        >
                          {expandedDetails["exp-elevenrush"] ? "▾ Hide details" : "▸ Details"}
                        </button>
                        <div className="exp-desc">
                          Built USA provider landing pages and sites using React.js
                          and Chakra UI for faster, lighter, SEO-optimized delivery.
                          Led email marketing campaigns that lowered lead acquisition
                          costs, maximizing ROI and increasing visibility for
                          potential customers.
                        </div>
                      </div>
                    </div>

                    <div
                      className="exp-item"
                      id="exp-sp"
                    >
                      <div className="exp-dot" />
                      <div className="exp-info">
                        <div className="exp-title">Web Design Analyst</div>
                        <div className="exp-meta">
                          <span className="exp-company">SP Intervention</span>
                          <span className="exp-year">2019 &ndash; 2020</span>
                        </div>
                        <div className="exp-tags">
                          <span className="exp-tag">WordPress</span>
                          <span className="exp-tag">UI/UX</span>
                          <span className="exp-tag">Healthcare</span>
                          <span className="exp-tag">B2B</span>
                        </div>
                        <button
                          className="expand-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleDetails("exp-sp");
                          }}
                        >
                          {expandedDetails["exp-sp"] ? "▾ Hide details" : "▸ Details"}
                        </button>
                        <div className="exp-desc">
                          Made UI improvements to the Wippe App and created
                          instructional video tutorials improving accessibility.
                          Produced social media content, landing pages, and eBooks for
                          B2C healthcare leads. Designed event stands, brochures,
                          and email marketing for B2B telemedicine and prosthetics
                          products.
                        </div>
                      </div>
                    </div>

                    <div
                      className="exp-item"
                      id="exp-mateus"
                    >
                      <div className="exp-dot" />
                      <div className="exp-info">
                        <div className="exp-title">
                          Marketing Analyst &middot; Multimedia Producer &middot;
                          Marketing Assistant
                        </div>
                        <div className="exp-meta">
                          <span className="exp-company">Grupo Mateus</span>
                          <span className="exp-year">2017 &ndash; 2018</span>
                        </div>
                        <div className="exp-tags">
                          <span className="exp-tag">Video</span>
                          <span className="exp-tag">Photography</span>
                          <span className="exp-tag">Retail</span>
                          <span className="exp-tag">Events</span>
                        </div>
                        <button
                          className="expand-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleDetails("exp-mateus");
                          }}
                        >
                          {expandedDetails["exp-mateus"] ? "▾ Hide details" : "▸ Details"}
                        </button>
                        <div className="exp-desc">
                          Implemented design thinking&ndash;based standardized
                          processes that tripled team productivity. Covered events
                          and store openings as a videomaker, maintaining engagement
                          across social media channels and driving customer
                          acquisition and sales.
                        </div>
                      </div>
                    </div>

                    <div
                      className="exp-item"
                      id="exp-universal"
                    >
                      <div className="exp-dot" />
                      <div className="exp-info">
                        <div className="exp-title">Graphic Designer</div>
                        <div className="exp-meta">
                          <span className="exp-company">Universal Software</span>
                          <span className="exp-year">2016</span>
                        </div>
                        <div className="exp-tags">
                          <span className="exp-tag">WordPress</span>
                          <span className="exp-tag">Landing Pages</span>
                          <span className="exp-tag">Video</span>
                          <span className="exp-tag">Lead Gen</span>
                        </div>
                        <button
                          className="expand-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleDetails("exp-universal");
                          }}
                        >
                          {expandedDetails["exp-universal"] ? "▾ Hide details" : "▸ Details"}
                        </button>
                        <div className="exp-desc">
                          Created presentation materials, photography, and social media
                          videos for real estate events. Developed optimized landing
                          pages and eBooks that captured valuable leads and drove
                          business growth.
                        </div>
                      </div>
                    </div>

                    <div
                      className="exp-item"
                      id="exp-ik"
                    >
                      <div className="exp-dot" />
                      <div className="exp-info">
                        <div className="exp-title">Marketing Trainee</div>
                        <div className="exp-meta">
                          <span className="exp-company">
                            IK Productions / Objetiva Productions
                          </span>
                          <span className="exp-year">2015</span>
                        </div>
                        <div className="exp-tags">
                          <span className="exp-tag">Graphic Design</span>
                          <span className="exp-tag">Social Media</span>
                          <span className="exp-tag">3D</span>
                          <span className="exp-tag">Events</span>
                        </div>
                      </div>
                    </div>

                    <div
                      className="exp-item"
                      id="exp-vetta"
                    >
                      <div className="exp-dot" />
                      <div className="exp-info">
                        <div className="exp-title">Marketing Trainee</div>
                        <div className="exp-meta">
                          <span className="exp-company">Vetta Group</span>
                          <span className="exp-year">2014</span>
                        </div>
                        <div className="exp-tags">
                          <span className="exp-tag">Graphic Design</span>
                          <span className="exp-tag">Video</span>
                          <span className="exp-tag">Web Dev</span>
                        </div>
                      </div>
                    </div>

                    <div
                      className="exp-item"
                      id="exp-gebauer"
                    >
                      <div className="exp-dot" />
                      <div className="exp-info">
                        <div className="exp-title">Marketing Trainee</div>
                        <div className="exp-meta">
                          <span className="exp-company">
                            Gebauer &ndash; Hardwood Floors
                          </span>
                          <span className="exp-year">2013</span>
                        </div>
                        <div className="exp-tags">
                          <span className="exp-tag">Graphic Design</span>
                          <span className="exp-tag">Web Dev</span>
                          <span className="exp-tag">PR Actions</span>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {section.id === "skills" && (
                  <div className="skills-grid">
                    <div className="skill-card">
                      <div className="skill-card-title">🖥 Front-End &amp; UI</div>
                      <div className="skill-card-items">
                        Figma &middot; WebFlow &middot; HTML &middot; CSS &middot;
                        JavaScript &middot; Three.js &middot; React.js &middot; Git
                      </div>
                    </div>
                    <div className="skill-card">
                      <div className="skill-card-title">📐 Visual Design</div>
                      <div className="skill-card-items">
                        Affinity &middot; Photoshop &middot; Illustrator &middot;
                        InDesign &middot; Figma &middot; XD &middot; Premiere &middot;
                        After Effects &middot; Blender
                      </div>
                    </div>
                    <div className="skill-card">
                      <div className="skill-card-title">🎯 Marketing &amp; UX</div>
                      <div className="skill-card-items">
                        Design Thinking &middot; User Journey &middot; HeatMap &middot;
                        A/B Test &middot; Miro
                      </div>
                    </div>
                    <div className="skill-card">
                      <div className="skill-card-title">🤖 Automation &amp; AI</div>
                      <div className="skill-card-items">
                        AI Automation &middot; Image/Video Gen &middot; AI Chat &middot;
                        AI Terminal Client &middot; AI Training
                      </div>
                    </div>
                    <div className="skill-card">
                      <div className="skill-card-title">🎬 Video Production</div>
                      <div className="skill-card-items">
                        Adobe Premiere &middot; After Effects &middot; DaVinci Resolve &
                        Blender
                      </div>
                    </div>
                    <div className="skill-card">
                      <div className="skill-card-title">🎲 3D</div>
                      <div className="skill-card-items">
                        Blender &middot; Three.js &middot; SketchUp &middot; After Effects &
                        Dimension
                      </div>
                    </div>
                  </div>
                )}

                {section.id === "education" && (
                  <div className="exp-item">
                    <div className="exp-dot" />
                    <div className="exp-info">
                      <div className="exp-title">
                        Degree in Advertising and Publicity
                      </div>
                      <div className="exp-meta">
                        <span className="exp-company">PUC Minas</span>
                        <span className="exp-year">2013 &ndash; 2017</span>
                      </div>
                      <div className="exp-tags">
                        <span className="exp-tag">
                          Pontifícia Universidade Católica de Minas Gerais
                        </span>
                      </div>
                    </div>
                  </div>
                )}

                {section.id === "courses" && (
                  <>
                    <div className="course-item">
                      <div className="course-year">2018</div>
                      <div className="course-info">
                        <div className="course-name">UX &amp; Design Thinking</div>
                        <div className="course-school">Udemy</div>
                        <div className="course-desc">
                          Product Strategy &middot; Idea Generation &middot; Planning &
                          Validation &middot; Metrics &middot; Design &middot; MVP
                        </div>
                      </div>
                    </div>
                    <div className="course-item">
                      <div className="course-year">2011</div>
                      <div className="course-info">
                        <div className="course-name">Web Master and Design</div>
                        <div className="course-school">Jovens Talentos</div>
                        <div className="course-desc">
                          Photoshop &middot; Illustrator &middot; Fireworks &middot;
                          Dreamweaver &middot; HTML &middot; CSS &middot; PHP &middot;
                          MySQL &middot; JavaScript
                        </div>
                      </div>
                    </div>
                    <div className="course-item">
                      <div className="course-year">2012</div>
                      <div className="course-info">
                        <div className="course-name">Computing Teacher</div>
                        <div className="course-school">Microlins</div>
                        <div className="course-desc">
                          Computer Maintenance &middot; Basic Computing &middot;
                          Microsoft Office (Excel, Word, PowerPoint)
                        </div>
                      </div>
                    </div>
                    <div className="course-item">
                      <div className="course-year">2009</div>
                      <div className="course-info">
                        <div className="course-name">
                          Computing Professionalizing Course
                        </div>
                        <div className="course-school">Cedaspy</div>
                        <div className="course-desc">
                          Web Design &middot; Graphic Design &middot; Computer Maintenance &
                          Basic Computing
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </section>
          );
        })}
      </div>
    </main>
  );
}